import {
  removeNonNumericAndSpaces,
  toJsonLd,
} from "@/components/package-components/utils";
import { SeoProps } from "./props";

export function Seo(props: SeoProps) {
  const formattedAddress = String(props?.address?.value ?? props?.address)
    .toLowerCase()
    .replace(/\s/g, "%20")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

  const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${formattedAddress}`; // Substitui espaços por "%20"

  const object = {
    name: props?.pageName,
    description: props?.descriptionPage,
    image: props?.siteLogo,
    hasMap: googleMapsUrl,
    openingHours: `Mo-Fr ${props?.openingHours}`,
    contactPoint: {
      "@type": "ContactPoint",
      telephone: `+55${removeNonNumericAndSpaces(
        String(props?.contactPhone?.value ?? props?.contactPhone)
      )}`,
      contactType: "customer service",
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={toJsonLd("CarDealership", { ...object })}
      />
      {/* Titles */}
      {typeof props.titlePage != "undefined" && (
        <title>{String(props?.titlePage?.value ?? props?.titlePage)}</title>
      )}

      {typeof props.titleOG != "undefined" && (
        <meta
          property="og:title"
          content={String(props?.titleOG?.value ?? props?.titleOG)}
        />
      )}

      {/* Descrições */}
      {typeof props.descriptionOG != "undefined" && (
        <meta
          property="og:description"
          content={String(props?.descriptionOG?.value ?? props?.descriptionOG)}
        />
      )}

      {typeof props.descriptionPage != "undefined" && (
        <meta
          name="description"
          content={String(
            props?.descriptionPage?.value ?? props?.descriptionPage
          )}
        />
      )}

      {/* Images and Icons */}
      {typeof props.imgOG != "undefined" && (
        <meta
          name="image"
          property="og:image"
          content={String(props?.imgOG?.value ?? props?.imgOG)}
        />
      )}

      {/*
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />

      {typeof props.twitterTitle != "undefined" && (
        <meta
          name="twitter:title"
          content={String(props?.twitterTitle?.value ?? props?.twitterTitle)}
        />
      )}

      {typeof props.descriptionPage != "undefined" && (
        <meta
          name="twitter:description"
          content={String(
            props?.twitterDescription?.value ?? props?.twitterDescription
          )}
        />
      )}

      {typeof props.twitterImg != "undefined" && (
        <meta
          name="twitter:image"
          content={String(props?.twitterImg?.value ?? props?.twitterImg)}
        />
      )}

      {/* Others */}
      <meta name="viewport" content="width=device-width, initial-scale=1" />

      <meta name="robots" content="follow, index" />

      <meta property="og:type" content="website" />
    </>
  );
}
